<template>
  <div class="cover">
    <div class="header">
      <div class="title">全场景覆盖</div>
      <div class="border"></div>
    </div>
    <div class="body">
      <div class="right">
        <img :src="mobilereportforrepair2" alt="" />
      </div>
      <div class="left">
        <div class="item" v-for="item in coverList" :key="item.id">
          <div class="title">{{ item.title }}</div>
          <div class="text">{{ item.text }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import mobilereportforrepair2 from "../../../../assets/product/mobilereportforrepair2.png";

export default {
  setup() {
    return reactive({
      mobilereportforrepair2: mobilereportforrepair2,
      coverList: [
        {
          id: 1,
          title: "有偿维修",
          text: "划分有偿维修区域，价格透明。",
        },
        {
          id: 2,
          title: "免费维修",
          text: "划分免费维修区域，自主选择，一键报修。",
        },
        {
          id: 3,
          title: "公区维修",
          text: "划分公共区域，发现问题，随时报修。",
        },
        {
          id: 4,
          title: "室内维修",
          text: "室内居家设施，专栏设置，多项选择，报修方便。",
        },
        {
          id: 5,
          title: "卫生保洁",
          text: "划分环境卫生、绿化设施维修区域，自主选择，一键报修。",
        },
      ],
    });
  },
};
</script>

<style scoped>
.cover {
  width: 100%;
  margin: 24px auto;
}
.header .title {
  font-size: 16px;
  text-align: center;
  margin-top: 24px;
}
.header .border {
  width: 16px;
  height: 2px;
  background: #248efb;
  margin: 4px auto 0;
}

.body {
  width: 92vw;
  margin: 0 auto;
  text-align: center;
  margin-top: 16px;
}
.body .left .item {
  margin-top: 12px;
  text-align: left;
  font-size: 14px;
}
.body .left .item .title {
  font-weight: 600;
}
.body .left .item .text {
  margin-top: 8px;
  font-size: 12px;color: #3d3d3d;
}

.body .right img {
  width: 174px;
}
</style>
